"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchDisplayCategoriesQueryDto = void 0;
const cursor_pagination_1 = require("../../cursor-pagination");
class SearchDisplayCategoriesQueryDto extends cursor_pagination_1.CursorPaginationOptions {
    search;
    flatten;
}
exports.SearchDisplayCategoriesQueryDto = SearchDisplayCategoriesQueryDto;
